export const state = {
  predictResult: [],
  selectionList: [],
  saveList: {},
  saveListItems: [],
  deleteMode: false,
  category: "",
  notMatchImage: "",
};
